/**
 * Create a new date with the specified time.
 *
 * @example
 *
 * const date = dateWithTime(new Date('2012-12-24T09:33:44.555Z'), 12);
 * // => 2012-12-24T12:00:00.000Z
 */
// oxlint-disable-next-line max-params
export function dateWithTime(
	date: Date,
	hours: number,
	min?: number,
	sec?: number,
	ms?: number,
) {
	const newDate = new Date(date);
	newDate.setUTCHours(hours, min ?? 0, sec ?? 0, ms ?? 0);
	return newDate;
}

/**
 * Check if a date is before another, ignoring time.
 *
 * @example
 *
 * isDateBefore(new Date('2012-12-24'), new Date('2012-12-25'));
 * // => true
 *
 * isDateBefore(new Date('2012-12-24'), new Date('2012-12-24'));
 * // => false
 *
 * isDateBefore(new Date('2012-12-24'), new Date('2012-12-23'));
 * // => false
 */
export function isDateBefore(date: Date, comparisonDate: Date) {
	return dateWithTime(date, 12) < dateWithTime(comparisonDate, 12);
}

/**
 * Check if a date is after another, ignoring time.
 *
 * @example
 *
 * isDateAfter(new Date('2012-12-24'), new Date('2012-12-25'));
 * // => false
 *
 * isDateAfter(new Date('2012-12-24'), new Date('2012-12-24'));
 * // => false
 *
 * isDateAfter(new Date('2012-12-24'), new Date('2012-12-23'));
 * // => true
 */
export function isDateAfter(date: Date, comparisonDate: Date) {
	return dateWithTime(date, 12) > dateWithTime(comparisonDate, 12);
}

/**
 * Subtract an amount of days from a date.
 *
 * @example
 *
 * subtractDaysFromDate(new Date('2026-12-31'), 30);
 * // => Date => Tue Dec 01 2026 23:59:59 GMT+0100
 *
 */
// TODO: tests
export function subtractDaysFromDate(date: Date, days: number) {
	const newDate = new Date(date);
	newDate.setDate(date?.getDate() - days);
	return newDate;
}
